module.exports = "/images/user-icon.svg?6a947d6890a35f8936072073c9eeea02";